export type AppEnvironment = 'local-devci' | 'devci' | 'local-uatrc' | 'uatrc' | 'production';

export const mockedEnvs = new Set<AppEnvironment>(['local-devci', 'devci']);
